import {
    Card,
    Typography
} from "antd";

import dayjs
    from "dayjs";

export default function ConversationBubble({
                                               message
                                           }) {

    const isBuyer =
        message.senderType ===
        "BUYER";

    return (

        <div
            style={{
                display: "flex",
                justifyContent:
                    isBuyer
                        ? "flex-end"
                        : "flex-start",
                marginBottom: 16
            }}
        >

            <Card

                size="small"

                style={{
                    maxWidth: "75%",
                    borderRadius: 16
                }}
            >

                <Typography.Text
                    strong
                >
                    {
                        message.senderType
                    }
                </Typography.Text>

                <div
                    style={{
                        marginTop: 8
                    }}
                >
                    {
                        message.content
                    }
                </div>

                <div
                    style={{
                        marginTop: 8,
                        fontSize: 11,
                        opacity: .7
                    }}
                >
                    {
                        dayjs(
                            message.createdAt
                        ).format(
                            "DD/MM/YYYY HH:mm"
                        )
                    }
                </div>

            </Card>

        </div>
    );
}